import { space } from '@frontend/components/src/theme/foundations/space';

import { PART_PARTS } from './partParts';
import type { PartStyleConfig } from './types';

export const PART_STYLE_CONFIG: PartStyleConfig = {
  parts: PART_PARTS,
  baseStyle: {
    container: {
      fontFamily: 'Roboto Mono',
      display: 'flex',
      alignItems: 'center',
    },
    thumbnailContainer: {
      backgroundImage: 'linear-gradient(to bottom right, #fff, #ddd)',
      alignSelf: 'stretch',
      flexShrink: '0',
      borderRadius: '2px',
      boxShadow: 'inset 0 0 0 1px #00000005',
    },
    labelContainer: {},
    labelPrefix: {
      textTransform: 'uppercase',
      color: 'feature.secondary',
      fontSize: '85%',
      lineHeight: '80%',
      marginInlineEnd: '0.25ch',
    },
    label: {
      wordBreak: 'break-word',
      _notLast: {
        marginInlineEnd: '0.5ch',
      },
      _last: {
        '& + *': {
          display: 'block',
          maxWidth: 'max-content',
        },
      },
    },
    labelPlaceholder: {
      wordBreak: 'break-word',
      color: 'feature.placeholder',
      _notLast: {
        marginInlineEnd: '0.5ch',
      },
      _last: {
        '& + *': {
          display: 'block',
          maxWidth: 'max-content',
        },
      },
    },
    secondaryLabel: {
      color: 'feature.secondary',
    },
  },
  variants: {
    default: {
      container: {
        p: `calc(${space[0.5]} - 1px)`,
        pr: `calc(${space[1]} - 1px)`,
        border: '1px solid',
        borderColor: 'separator.border',
        borderRadius: 'md',
      },
    },
    borderless: {
      container: {
        border: '1px solid transparent',
      },
    },
  },
  sizes: {
    sm: {
      container: {
        gap: 0.5,
      },
      labelContainer: {
        fontSize: 'sm',
        lineHeight: '1rem',
      },
      thumbnailContainer: {
        minHeight: 4.5,
        width: 4.5,
      },
    },
    md: {
      container: {
        gap: 0.75,
      },
      labelContainer: {
        fontSize: 'sm',
        lineHeight: '1rem',
      },
      thumbnailContainer: {
        minHeight: 5,
        width: 5,
      },
    },
    lg: {
      container: {
        gap: 0.75,
      },
      labelContainer: {
        fontSize: 'sm',
        lineHeight: '1rem',
      },
      thumbnailContainer: {
        minHeight: 6,
        width: 6,
      },
    },
    xl: {
      container: {
        gap: 0.75,
      },
      labelContainer: {
        fontSize: 'md',
        lineHeight: '1.25rem',
      },
      thumbnailContainer: {
        minHeight: 10,
        width: 10,
      },
    },
  },
  defaultProps: {
    size: 'sm',
    variant: 'default',
  },
};
